export type ThemePreference = 'light' | 'dark' | 'auto'

const STORAGE_KEY = 'classificado.theme'

export function get_theme_preference(): ThemePreference {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return raw === 'dark' || raw === 'auto' ? raw : 'light'
  } catch {
    return 'light'
  }
}

export function set_theme_preference(pref: ThemePreference): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, pref)
  } catch {
    // no-op
  }
  apply_theme(pref)
}

export function init_theme(): void {
  apply_theme(get_theme_preference())
}

function apply_theme(pref: ThemePreference): void {
  const prefers_dark = window.matchMedia?.('(prefers-color-scheme: dark)').matches === true
  const resolved = pref === 'auto' ? (prefers_dark ? 'dark' : 'light') : pref
  document.documentElement.dataset.theme = resolved
  document.documentElement.dataset.themePref = pref
  document.documentElement.style.colorScheme = resolved
  document.getElementById('classificado-theme-color')?.setAttribute('content', resolved === 'dark' ? '#111827' : '#2563eb')
}
